// The Inbox kinds for Poneva Everywhere's agent permissions (PR2-DESIGN §A4, §E): an Agent
// request a person decides in the canvas, and the Agent activity updates that say what an
// agent did on its own. Both register with the Inbox's extension registry, so the Inbox's
// own model and copy are not touched.
import { useNamespaceCopy } from '@/i18n/ns';
import agentPermissionsCopy from '@/i18n/ns/agent-permissions';
import agentRequestsCopy from '@/i18n/ns/agent-requests';
import { registerInboxKind } from '../inbox-extensions';
import { useIntlLocale } from '../intl-locale';
import { AgentRequestDetail } from './request-detail';
import { requestHeading, rowMeta } from './meta';
import type { InboxItem } from '../inbox-api';

export const AGENT_INBOX_KINDS = { request: 'agent_request', activity: 'agent_activity' } as const;

registerInboxKind({
  kind: AGENT_INBOX_KINDS.request,
  icon: 'agents',
  useLabel: () => useNamespaceCopy(agentRequestsCopy).kindAgentRequest,
  Detail: AgentRequestDetail,
  useRowMeta: () => {
    const copy = useNamespaceCopy(agentRequestsCopy);
    const permissions = useNamespaceCopy(agentPermissionsCopy);
    return (entry) => rowMeta(copy, entry, permissions);
  },
  useHeading: () => {
    const copy = useNamespaceCopy(agentRequestsCopy);
    const permissions = useNamespaceCopy(agentPermissionsCopy);
    const locale = useIntlLocale();
    return (entry) => requestHeading(copy, entry as InboxItem, locale, permissions);
  },
});

registerInboxKind({
  kind: AGENT_INBOX_KINDS.activity,
  icon: 'agents',
  useLabel: () => useNamespaceCopy(agentRequestsCopy).kindAgentActivity,
  // An update has no decision: the Inbox draws it, the kind only names it and its row.
  Detail: () => null,
  useRowMeta: () => {
    const copy = useNamespaceCopy(agentRequestsCopy);
    const permissions = useNamespaceCopy(agentPermissionsCopy);
    return (entry) => rowMeta(copy, entry, permissions);
  },
});
